// Mes données (lot 5.3) : tout télécharger (une archive zip qui se lit sans Alfred), et supprimer son compte. La
// suppression redemande le mot de passe et une case cochée : elle ne se rattrape pas.

import { type FormEvent, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { api } from '../lib/api';

export function MesDonnees({ actions }: { actions: Actions }) {
  const [motDePasse, setMotDePasse] = useState('');
  const [compris, setCompris] = useState(false);
  const [envoi, setEnvoi] = useState(false);

  const supprimer = async (e: FormEvent) => {
    e.preventDefault();
    setEnvoi(true);
    try {
      await api.supprimerMonCompte(motDePasse);
      window.location.hash = '#/connexion';
      window.location.reload();
    } catch (x) {
      actions.toast({ texte: (x as Error).message, erreur: true });
      setEnvoi(false);
    }
  };

  return (
    <main className="ecran">
      <EnTeteRetour titre="Mes données" retour="#/reglages" />

      <Fenetre>
        <span className="display" style={{ fontWeight: 500 }}>Tout télécharger</span>
        <p className="muted" style={{ margin: 0, fontSize: 13 }}>
          Une archive avec vos notes (en Markdown), vos rappels, vos conversations, ce qu’Alfred sait de vous et vos réglages,
          dans des formats qui se lisent sans Alfred. Les mots de passe de vos connexions n’y sont pas.
        </p>
        <a className="btn principal" href="/api/moi/export" download>Télécharger mes données</a>
      </Fenetre>

      <Fenetre>
        <span className="display" style={{ fontWeight: 500 }}>Supprimer mon compte</span>
        <p className="muted" style={{ margin: 0, fontSize: 13 }}>
          Tout ce qui est à vous est effacé du serveur aussitôt : notes, rappels, conversations, connexions et leurs
          copies. Les sauvegardes l’oublient au bout de 30 jours au plus. Si vous êtes seul dans votre foyer, le foyer
          disparaît avec vous. Pensez à télécharger vos données avant.
        </p>
        <form className="formulaire" onSubmit={(e) => void supprimer(e)}>
          <input className="saisie texte" type="password" placeholder="Votre mot de passe" autoComplete="current-password" value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} aria-label="Mot de passe" />
          <label className="entretien-case">
            <input type="checkbox" checked={compris} onChange={(e) => setCompris(e.target.checked)} />
            <span>Je comprends que tout sera effacé, sans retour possible.</span>
          </label>
          <button className="btn danger" disabled={!motDePasse || !compris || envoi}>Supprimer mon compte</button>
        </form>
      </Fenetre>
    </main>
  );
}
